(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CommissionListController', CommissionListController);

    CommissionListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'Commission', 'CommissionCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function CommissionListController($scope, $state, ParseLinks, AlertService, Commission, CommissionCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        vm.editCommission = editCommission;
        vm.searchKeyPress = searchKeyPress;
        vm.newCommission = newCommission;
        vm.clearSearch = clearSearch;

        vm.findApproveStatusStyle = findApproveStatusStyle;

        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                CommissionCustom.getAllCompanyCommission().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CommissionCustom.getAllCompanyCommission().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.commissions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }


        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editCommission(commission) {
            $state.go('supplierPanel-v2.editCommission', {id: commission.id});
        }

        function newCommission() {
            var result;

            // result = Principal.hasSpecialFeatureAccess("Commission");
            // if (!result) {
            //     DialogService.showAlert("عدم دسترسی","برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
            //     return;
            // }
            $state.go('supplierPanel-v2.newCommission');
        }

        function clearSearch() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findApproveStatusStyle(approveStatus) {
            return "marketing-approve-status marketing-approve-status-" + approveStatus;
        }

    }
})();
